// extracted by mini-css-extract-plugin
export default {"button":"SortDesc_button__f9-yW"};